/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';

import { User       } from '@/models/user';

import { Logger                } from '@/util/logger';
import {UserService} from "@/services/user.service";
import {AuthenticationService} from "@/services/authentication.service";
import {ProjectService} from "@/services/project.service";
import {IOrganizationRow} from "@/screens/administration/i.organization.row";
import {OrganizationService} from "@/services/organization.service";
import {ActivatedRoute, ParamMap} from "@angular/router";
import {Subscription} from "rxjs";
import {first} from "rxjs/operators";
import {ISubdivisionRow} from "@/screens/administration/i.subdivision.row";
import {IProjectRow} from "@/screens/administration/i.project.row";
import {IUserRow} from "@/screens/administration/i.user.row";
import {Inplace} from "primeng/inplace";
import {errorAsText, fromMySQLDate} from "@/util/util";

@Component({
  standalone: false,
  templateUrl: 'organization.details.component.html'
})

/**
 *
 * @class OrganizationDetailsComponent
 *
 * @brief view/edit details for a specific organization
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2022
 *
 */
export class OrganizationDetailsComponent implements OnInit, OnDestroy {

  /** the logged-in user */
  public viewer: User                   = null;

  /** the organization key */
  public key: string                = '';

  /** the project being viewed */
  public organization: IOrganizationRow = null;

  /** our subscription to the current route */
  private routeListen: Subscription     = null;

  /** the selected auto-completed admin user */
  public newAdmin: IUserRow          = null;

  /** the auto-completed admins */
  public searchAdmins: IUserRow[]    = [];

  /** all possible subdivisions */
  public allSubs: ISubdivisionRow[] = [];

  /** most recent search term */
  private lastTerm: string          = '';

  /** the project key to use for creation */
  public prjCreateKey: string    = '';

  /** the project name to use for creation */
  public prjCreateName: string   = '';

  /** is the current key/project name valid for creating an project? */
  public prjInputValid: boolean  = false;

  /** standard constructor */
  constructor(
    private auth: AuthenticationService,
    private users: UserService,
    private route: ActivatedRoute,
    private prjservice: ProjectService,
    private orgservice: OrganizationService,
    private cdRef:      ChangeDetectorRef
  ) {

    let od: OrganizationDetailsComponent = this;

    od.organization = {
      key:         'NONE',
      name:        'None',
      logo_url:    '/assets/images/default-project-logo.png',
      description: 'No Description',
      pending_users: []
    }
  }

  /** on page setup */
  ngOnInit() {

    Logger.debug('[OrganizationDetailsComponent] init...');

    let od: OrganizationDetailsComponent = this;

    /* who is viewing the page */

    od.viewer = od.auth.userOfSession;

    od.routeListen = od.route.paramMap.subscribe((params: ParamMap) => {

      /* figure out the 'key' ... */

      od.key = params.get('key');

      /* fetch the project... */

      od.refresh();

    });


  }

  /** check if viewer is an admin for this project */
  isAdmin() {

    let od: OrganizationDetailsComponent = this;
    let viewer: User = od.auth.userOfSession;

    /*
     * you are a project administrator if:
     *
     *   - you are system admin
     *   - you are an admin in the org of the project
     *
     */

    if (od.auth.isAdmin()) {

      /* system admin */

      return true;
    }

    let found: boolean = false;

    od.organization.admins.forEach((item: IUserRow) => {

      if (item.id == viewer.id.toString()) {

        found = true;
      }

    });

    return found;
  }

  isSystemAdmin(): boolean {

    let od: OrganizationDetailsComponent = this;

    return od.auth.isAdmin();
  }

  /** check the "key" input for creating a project */
  checkKey(event = null) {

    let od: OrganizationDetailsComponent = this;

    let name: string = $(`#createprojectlight`).val().toString().trim();
    let key: string = $(`#createprojectkeylight`).val().toString();

    /* clear the current error */

    od.prjInputValid = true;

    $(`.prjcreateerror`).html('');

    /* they have to pick an org */

    if (!od.organization) {

      $(`.prjcreateerror`).html('Project must belong to an organization.');

      od.prjInputValid = false;

      od.cdRef.detectChanges();

      return false;
    }

    /* any validation issues? */

    if (!/^[a-zA-Z][_a-zA-Z0-9]+$/.test(key)) {

      $(`.prjcreateerror`).html('Project key must be of pattern [a-zA-Z][_a-zA-Z0-9]+');

      od.prjInputValid = false;

      od.cdRef.detectChanges();

      return false;
    }

    if (!name) {

      $(`.prjcreateerror`).html('Project name can not be empty.');

      od.prjInputValid = false;

      od.cdRef.detectChanges();

      return false;
    }

    if (event != null) {

      /* if it's a key up change, only trigger on RETURN */

      if (event.key == 'Enter') {

        od.createProject(true);
      }

    }

    /* clear to proceed! */

    od.cdRef.detectChanges();

    return true;
  }

  clearPicker() {

    let od: OrganizationDetailsComponent = this;

    $(`#createprojectlight`).val('');
    $(`#createprojectkeylight`).val('');

    od.prjInputValid = false;

    od.cdRef.detectChanges();
  }

  createProject(noCheck: boolean  = false) {

    let od: OrganizationDetailsComponent = this;
    let name: string              = $(`#createprojectlight`).val().toString();
    let key: string               = $(`#createprojectkeylight`).val().toString();
    let org: IOrganizationRow     = od.organization;

    if (!noCheck) {

      /* we haven't checked the values yet */

      if (!od.checkKey()) {

        /* validation errors */

        return;
      }
    }

    od.clearPicker();

    Logger.debug(`[OrganizationDetailsComponent] creating new project: '${name}', '${key}'...`);

    od.prjservice.create({name, key, rv_organizations_id: org.id})
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          if (data.result) {

            data = data.result;
          }

          Logger.debug(`[OrganizationDetailsComponent] project created, refreshing...`);

          od.organization.projects.push(data);

          od.organization.projects.sort((a: IProjectRow, b: IProjectRow) => {

            let cmp: number = a.name.localeCompare(b.name);

            if (cmp == 0) {

              /* names are the same, compare on key (guarenteed to be unique) */

              cmp = a.key.localeCompare(b.key)
            }

            od.cdRef.detectChanges();

            return cmp;
          });

        },

        error: (error: any): void => {

          $(`.prjcreateerror`).html(errorAsText(error));

          Logger.error(`[OrganizationDetailsComponent] could not create project: `, error);
        }

      });

  }

  /** format the items in the autocomplete user dropdown */
  formatMatch(match: string) {

    let od: OrganizationDetailsComponent = this;

    return match.replace(od.lastTerm, `<span class="autocomplete-hightlight-term">${od.lastTerm}</span>`);
  }

  /** helper for new user auto-complete, to lookup partial user matches */
  search(event) {

    let term: string                     = event.query;
    let od: OrganizationDetailsComponent = this;

    Logger.debug(`[OrganizationDetailsComponent] need auto-complete on '${term}'...`);

    od.lastTerm = term;

    od.users.autocomplete(term)
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          if (data.result) {

            data = data.result;
          }

          od.searchAdmins = [];

          data.forEach((item) => {

            /* only keep the matches which are not already members of this project */

            if (od.organization.admins.find(x => x.id == item.id)) {

              return;

            }

            if (item.is_pending) {

              /* we deal with pending users directly. */

              return;
            }

            od.searchAdmins.push(item);

          });

          Logger.debug(`[OrganizationDetailsComponent] matches: `, od.searchAdmins);

          od.cdRef.detectChanges();
        },

        error: (error: any): void => {

          Logger.error(`[OrganizationDetailsComponent] could not autocomplete: `, error);
        }

      });
  }

  /** set a new name for the given organization */
  saveOrgName(id: number, name: string) {

    let od: OrganizationDetailsComponent = this;
    let org: IOrganizationRow            = od.organization;

    if (!org) {

      return ;
    }

    /* update locally */

    od.organization.name = name;

    /* update the database... */

    od.orgservice.update(id, {name})
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          Logger.debug(`[OrganizationDetailsComponent] saved name: `, data);

          od.cdRef.detectChanges();
        },

        error: (error: any): void => {

          Logger.error(`[OrganizationDetailsComponent] could not save new organization name: `, error);

        }

      });

  }

  /** set a new description for the given organization */
  saveOrgDescription(id: number, description: string) {

    let od: OrganizationDetailsComponent = this;
    let org: IOrganizationRow            = od.organization;

    if (!org) {

      return ;
    }

    /* update locally */

    od.organization.description = description;

    /* update the database... */

    od.orgservice.update(id, {description})
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          Logger.debug(`[OrganizationDetailsComponent] saved description: `, data);

          od.cdRef.detectChanges();
        },

        error: (error: any): void => {

          Logger.error(`[OrganizationDetailsComponent] could not save new organization description: `, error);

        }

      });

  }

  /** set a new description for the given organization */
  saveOrgLogo(id: number, logo_url: string) {

    let od: OrganizationDetailsComponent = this;
    let org: IOrganizationRow            = od.organization;

    if (!org) {

      return ;
    }

    /* update locally */

    od.organization.logo_url = logo_url;

    /* update the database... */

    od.orgservice.update(id, {logo_url})
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          Logger.debug(`[OrganizationDetailsComponent] saved logo: `, data);

          od.cdRef.detectChanges();
        },

        error: (error: any): void => {

          Logger.error(`[OrganizationDetailsComponent] could not save new organization logo: `, error);

        }

      });

  }

  orgEditLogoKey(event, id: number, component: Inplace) {

    let od: OrganizationDetailsComponent = this;
    let value: string = $(`.orgclass-logo-${id} input`).val().toString();

    if (event.key != 'Enter') {

      return ;
    }

    Logger.debug(`[OrganizationDetailsComponent] org logo editor RETURN (${id}) => '${value}': `, event);

    od.saveOrgLogo(id, value);

    component.deactivate();
  }

  orgEditLogoDeactivate(id: number, component: Inplace) {

    let od: OrganizationDetailsComponent = this;
    let value: string = $(`.orgclass-logo-${id} input`).val().toString();

    Logger.debug(`[OrganizationDetailsComponent] deactivating org logo editor (${id}) => '${value}': `, component);

    od.saveOrgLogo(id, value);

  }

  orgEditLogoActivate(id: number, component: Inplace) {

    let od: OrganizationDetailsComponent = this;

    Logger.debug(`[OrganizationDetailsComponent] activating org logo editor (${id}): `, component);



  }

  orgEditDescKey(event, id: number, component: Inplace) {

    let od: OrganizationDetailsComponent = this;
    let value: string = $(`.orgclass-desc-${id} input`).val().toString();

    if (event.key != 'Enter') {

      return ;
    }

    Logger.debug(`[OrganizationDetailsComponent] org desc editor RETURN (${id}) => '${value}': `, event);

    od.saveOrgDescription(id, value);

    component.deactivate();
  }

  orgEditDescDeactivate(id: number, component: Inplace) {

    let od: OrganizationDetailsComponent = this;
    let value: string = $(`.orgclass-desc-${id} input`).val().toString();

    Logger.debug(`[OrganizationDetailsComponent] deactivating org desc editor (${id}) => '${value}': `, component);

    od.saveOrgDescription(id, value);

  }

  orgEditDescActivate(id: number, component: Inplace) {

    let od: OrganizationDetailsComponent = this;

    Logger.debug(`[OrganizationDetailsComponent] activating org desc editor (${id}): `, component);



  }

  orgEditNameKey(event, id: number, component: Inplace) {

    let od: OrganizationDetailsComponent = this;
    let value: string = $(`.orgclass-name-${id} input`).val().toString();

    if (event.key != 'Enter') {

      return ;
    }

    Logger.debug(`[OrganizationDetailsComponent] org editor RETURN (${id}) => '${value}': `, event);

    od.saveOrgName(id, value);

    component.deactivate();
  }

  orgEditNameDeactivate(id: number, component: Inplace) {

    let od: OrganizationDetailsComponent = this;
    let value: string = $(`.orgclass-name-${id} input`).val().toString();

    Logger.debug(`[OrganizationDetailsComponent] deactivating org name editor (${id}) => '${value}': `, component);

    od.saveOrgName(id, value);

  }

  orgEditNameActivate(id: number, component: Inplace) {

    let od: OrganizationDetailsComponent = this;

    Logger.debug(`[OrganizationDetailsComponent] activating org name editor (${id}): `, component);




  }

  refreshMembers(): void {

    let od: OrganizationDetailsComponent = this;

    /* make sure date/time stamps are local the user's browser */

    /* sort the users by date then by name */

    if (od.organization.pending_users) {

      od.organization.pending_users = od.organization.pending_users.map((item: IUserRow): IUserRow => {

        item.created_at = fromMySQLDate(item.created_at).toLocaleString().slice(0, 19).replace(',', '');
        item.updated_at = fromMySQLDate(item.updated_at).toLocaleString().slice(0, 19).replace(',', '');

        return item;
      });

      od.organization.pending_users.sort((ua: IUserRow, ub: IUserRow): number => {

        let aParts: string[]  = ua.created_at.split(/[- :]/);
        let bParts: string[]  = ub.created_at.split(/[- :]/);

        let a: Date = new Date(Date.UTC(
          parseInt(aParts[0]),
          parseInt(aParts[1])-1,
          parseInt(aParts[2]),
          parseInt(aParts[3]),
          parseInt(aParts[4]),
          parseInt(aParts[5])
        ));

        let b: Date = new Date(Date.UTC(
          parseInt(bParts[0]),
          parseInt(bParts[1])-1,
          parseInt(bParts[2]),
          parseInt(bParts[3]),
          parseInt(bParts[4]),
          parseInt(bParts[5])
        ));

        /* sort first by date */

        let cmp: number = b.valueOf() - a.valueOf();

        if (cmp != 0) {

          return cmp;
        }

        /* dates are the same, sort by name */

        return ua.display_name.localeCompare(ub.display_name);
      });
    }

    if (od.organization.admins) {

      od.organization.admins = od.organization.admins.map((item: IUserRow): IUserRow => {

        item.created_at = fromMySQLDate(item.created_at).toLocaleString().slice(0, 19).replace(',', '');
        item.updated_at = fromMySQLDate(item.updated_at).toLocaleString().slice(0, 19).replace(',', '');

        return item;
      });

      od.organization.admins.sort((ua: IUserRow, ub: IUserRow): number => {

        let aParts: string[]  = ua.created_at.split(/[- :]/);
        let bParts: string[]  = ub.created_at.split(/[- :]/);

        let a: Date = new Date(Date.UTC(
          parseInt(aParts[0]),
          parseInt(aParts[1])-1,
          parseInt(aParts[2]),
          parseInt(aParts[3]),
          parseInt(aParts[4]),
          parseInt(aParts[5])
        ));

        let b: Date = new Date(Date.UTC(
          parseInt(bParts[0]),
          parseInt(bParts[1])-1,
          parseInt(bParts[2]),
          parseInt(bParts[3]),
          parseInt(bParts[4]),
          parseInt(bParts[5])
        ));

        /* sort first by date */

        let cmp: number = b.valueOf() - a.valueOf();

        if (cmp != 0) {

          return cmp;
        }

        /* dates are the same, sort by name */

        return ua.display_name.localeCompare(ub.display_name);
      });
    }

  }

  refresh() {

    let od: OrganizationDetailsComponent = this;

    Logger.debug(`[OrganizationDetailsComponent] data fill for ${od.key}`);

    od.orgservice.dump(od.key)
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          od.organization = null;

          if (data.result) {

            data = data.result;
          }

          od.organization = data.organization;

          Logger.debug(`[OrganizationDetailsComponent] organization: `, od.organization);

          od.allSubs = [];

          data.subdivisions.forEach((item) => {

            od.allSubs.push(item);
          });

          od.allSubs.sort((a: ISubdivisionRow, b: ISubdivisionRow) => {

            return a.name.localeCompare(b.name);
          });

          od.organization.projects.sort((a: IProjectRow, b: IProjectRow) => {

            let cmp: number = a.name.localeCompare(b.name);

            if (cmp == 0) {

              /* names are the same, compare on key (guarenteed to be unique) */

              cmp = a.key.localeCompare(b.key)
            }

            return cmp;
          });

          od.refreshMembers();

          od.cdRef.detectChanges();

          Logger.debug(`[OrganizationDetailsComponent] all subs: `, od.allSubs);

        },

        error: (error: any): void => {

          Logger.error(`[OrganizationDetailsComponent] could not fetch organization details: `, error);

        }

      });

  }

  /** just approve a pending user */
  approve(user: IUserRow) {

    let od: OrganizationDetailsComponent = this;

    Logger.debug(`[OrganizationDetailsComponent] approve only on:`, user);

    od.users.update(user.id, {
      is_pending: false,
      is_active: true,
      is_suspended: false
    })
      .pipe(first())
      .subscribe({

        next: (data: any) => {

          if (data.result) {

            data = data.result;
          }

          Logger.debug(`[OrganizationDetailsComponent] edited!`, data);

          od.organization.pending_users = od.organization.pending_users.filter(x => x.id != data.id);

          od.cdRef.detectChanges();
        },

        error: (error: any): void => {

          Logger.error(`[OrganizationDetailsComponent] could not approve new user:`, error);
        }

      });

  }

  /** approve a pending user, AND add them as an organizational admin as well */
  approveAndLink(user: IUserRow) {

    let od: OrganizationDetailsComponent = this;

    Logger.debug(`[OrganizationDetailsComponent] approve and add as member on:`, user);

    /* just link them in as normal; the backend will do an implied approval when it links */

    od.users.linkOrganization(od.organization.id, Number(user.id))
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          if (data.result) {

            data = data.result;
          }

          od.organization = data;

          od.refreshMembers();

          Logger.debug(`[OrganizationDetailsComponent] linked!`, od.organization);


          od.cdRef.detectChanges();
        },

        error: (error: any): void => {

          Logger.error(`[OrganizationDetailsComponent] could not approve and link new admin:`, error);
        }

      });

  }

  /** they picked a user from the auto-complete "add user" dropdown, add them! */
  linkAdmin(event) {

    let od: OrganizationDetailsComponent = this;
    let toLink: IUserRow                 = od.newAdmin;

    od.newAdmin = null;

    Logger.debug(`[OrganizationDetailsComponent] adding member:`, toLink);

    od.users.linkOrganization(od.organization.id, Number(toLink.id))
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          if (data.result) {

            data = data.result;
          }

          od.organization = data;

          od.refreshMembers();

          Logger.debug(`[OrganizationDetailsComponent] linked!`, od.organization);

          od.cdRef.detectChanges();
        },

        error: (error: any): void => {

          Logger.error(`[OrganizationDetailsComponent] could not link new member:`, error);
        }

      });

  }

  /** update ourselves when the project list deletes a project */
  projectDeleted(project: IProjectRow): void {

    let od: OrganizationDetailsComponent = this;

    Logger.debug('[MyProjectsComponent] project deleted: ', project);

    od.cdRef.detectChanges();
  }

  /** update the org admin list when an admin is unlinked */
  unlinkAdmin(removed: IUserRow) {

    let od: OrganizationDetailsComponent = this;

    od.organization.admins = od.organization.admins.filter(x => x.id != removed.id);

    od.cdRef.detectChanges();

  }

  /** cleanup! */
  ngOnDestroy() {

    let od: OrganizationDetailsComponent = this;

    od.routeListen.unsubscribe();
  }
}

